import React, { createContext } from "react";

export type RadioGroupContextType = {
  name?: string;
  /**
   * Radio Components
   */
  value?: string | number;
  /**
   * Value when want to use the Radio as a uncontrolled component
   */
  defaultValue?: string | number;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const RadioGroupContext = createContext<RadioGroupContextType | null>(
  null,
);
